import { Stack } from 'expo-router';
import React from 'react';

function Layout() {
  return <Stack />;
}

export default Layout;
